import type { ReactNode } from 'react'
import { Header } from './Header'

interface AppShellProps {
  children: ReactNode
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      {/* Container + padding matched to admin-dashboard's own shell (max-w-[1400px], px-8/py-8
          there; a notch tighter here because this view is also embedded in the partners portal
          iframe, where every px of chrome is taken out of the content). */}
      <main className="max-w-[1400px] mx-auto px-4 sm:px-6 py-6">
        {children}
      </main>
    </div>
  )
}
